export default {
      id: "ear-usage",
      viewBox: "0 0 200 200",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#ear",
      toString: function () {
        return this.url;
      }
    }